import "./VoiceStatusIndicatorComponent.scss";

interface VoiceStatusIndicatorComponentProps {
    isSpeaking: boolean;
    isListening: boolean;
    className?: string;
    audioInputVolume?: number; // 0-1 range for audio input volume
}

const VoiceStatusIndicatorComponent = ({
    isSpeaking,
    isListening,
    className = "",
    audioInputVolume = 0
}: VoiceStatusIndicatorComponentProps) => {
    // Determine volume level class based on audio input volume
    const getVolumeClass = (volume: number): string => {
        if (volume < 0.1) return 'volume-low';
        if (volume < 0.3) return 'volume-medium';
        if (volume < 0.6) return 'volume-high';
        return 'volume-very-high';
    };

    const volumeClass = getVolumeClass(audioInputVolume);

    return (
        <div className={`voice-status-indicator ${className}`}>
            {/* Speaking Indicator */}
            {isSpeaking && (
                <div className="voice-status-indicator__speaking">
                    <div className="voice-status-indicator__speaking-content">
                        <div className="voice-status-indicator__sound-waves">
                            <div className="wave"></div>
                            <div className="wave"></div>
                            <div className="wave"></div>
                            <div className="wave"></div>
                            <div className="wave"></div>
                            <div className="wave"></div>
                            <div className="wave"></div>
                        </div>
                        <span>AI is speaking...</span>
                    </div>
                </div>
            )}
            
            {/* Listening Indicator */}
            {isListening && (
                <div className="voice-status-indicator__listening">
                    <div className="voice-status-indicator__listening-content">
                        <span>Listening...</span>
                        <div className="voice-status-indicator__mic-waves">
                            <div className={`wave ${volumeClass}`}></div>
                            <div className={`wave ${volumeClass}`}></div>
                            <div className={`wave ${volumeClass}`}></div>
                            <div className={`wave ${volumeClass}`}></div>
                            <div className={`wave ${volumeClass}`}></div>
                            <div className={`wave ${volumeClass}`}></div>
                            <div className={`wave ${volumeClass}`}></div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default VoiceStatusIndicatorComponent;
